import { forwardRef } from 'react';

type CustomFileInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  buttonComponent: React.ReactNode;
};

export const CustomFileInput = forwardRef<HTMLInputElement, CustomFileInputProps>(
  ({ buttonComponent, ...props }, ref) => {
    return (
      <>
        <input type="file" ref={ref} className="hidden" {...props} />
        {buttonComponent}
      </>
    );
  }
);

CustomFileInput.displayName = 'CustomFileInput';
